import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "Highmark",
  shortName: "Highmark",
  slug: "highmark-insurance",
  seoTitle: "Highmark Insurance TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how Highmark Insurance policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "Highmark TMS coverage, Highmark SPRAVATO authorization, Highmark mental health benefits Coral Springs FL, Highmark depression treatment Florida",
};

export const HighmarkInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default HighmarkInsurance;
